window.RC = {
  "dataSending" : false,

  "init" : function(view){
    console.log("RC Init");

    var preload = $(".preload");
    setTimeout(function(){
      preload.addClass("out");
    },1000);

    setTimeout(function(){
      preload.remove();
      this.scroll.init();
      this.sections.init();
    }.bind(this),2000);
  },

  sections : {
    "init" : function(){
      this.intro.setup();
      this.game.setup();
      this.lanuit.setup();
      this.sectionAnims.setup();

      var sections = $(".section-default");
      $.each($(".section-bg .btnArea"),function(index,elem){
        if(index == 5) return;

        $(elem).on("click",function(){
          window.RC.scroll.scrollTo($(sections[index]));
        });
      }.bind(this));
      if(window.RC.scroll.smoothScroll){
        var gameNavs =  $(".swiper-button-white");

        $("body").click(function(e) {
          var activeBtn = $(".section-bg.active .btnArea");
          if(activeBtn.length == 0) return;

          var index = activeBtn.parent().attr("data-index");

          if(index != 6){
            var coords = activeBtn.position();
            var w = activeBtn.width();
            var h = activeBtn.height();
            if(event.clientX >= coords.left && event.clientX <= coords.left + w ){
              if(event.clientY >= coords.top && event.clientY <= coords.top + h ){
                window.RC.scroll.scrollTo($(sections[index-1]));
              }
            }
          }else{
            for(var i = 0; i < gameNavs.length; i++){
              var activeBtn = $(gameNavs[i]);
              var coords = activeBtn.offset();
              var w = activeBtn.width();
              var h = activeBtn.height();
              if(event.clientX >= coords.left && event.clientX <= coords.left + w ){
                if(event.clientY >= coords.top && event.clientY <= coords.top + h ){
                  activeBtn.trigger("fake-click");
                  break;
                }
              }
            }
          }
        });
      }
    },

    "intro" : {
      "started" : false,
      "scrollAnim" : null,
      "scrollIndicator" : null,

      "setup" : function(){
        var event = (device.desktop()) ? "wheel" : "touchstart";
        var afterWheel = function(){
          $(window).off(event,onWheel);
        }.bind(this);
        var onWheel = this.start.bind(this,afterWheel);
        $(window).on(event,onWheel);

        this.scrollIndicator = $("#scroll-indicator");
        this.scrollAnim = lottie.loadAnimation({
          container: this.scrollIndicator.find("div").get(0),
          renderer: 'svg',
          loop: true,
          autoplay: true,
          path: '/img/scroll.json'
        });
        this.showScrollAnim();

        this.scrollIndicator.off("click");
        this.scrollIndicator.on("click",function(){
          $(window).trigger(event);
        }.bind(this));
      },

      "start" : function(wheelCancel){
        this.hideScrollAnim();

        this.scrollIndicator.off("click");

        if(this.started) return;
        this.started = true;
        wheelCancel();
        setTimeout(function(){RC.scroll.enable();},2000);
        setTimeout(function(){
          $("section.intro").addClass("animate");
          this.updateScrollAnim();
        }.bind(this),300);

        if(device.desktop())
          this.checkScrollAndShowScrollAnim();
        else
          this.removeScrollAnim();

        this.scrollIndicator.off("click");
        this.scrollIndicator.on("click",function(){
          var sections = $(".section-default");
          window.RC.scroll.scrollTo($(sections[0]));
          //$(window).trigger(event);
        }.bind(this));
      },

      "end" : function(){
        this.scrollIndicator.off("click");
        $("section.intro").addClass("end");

        $.each($("section.intro").children(),function(index,elem){
          elem = $(elem);
          if(!elem.hasClass("bg")) elem.remove();
        });
      },

      "reverse" : function(){
        $(".section-anim").removeClass("active");
        $(".section-bg").removeClass("active");
        $("section.intro").removeClass("end");
      },

      "showScrollAnim" : function(){
        if(this.scrollAnim == null) return;

        this.scrollIndicator.addClass("in");
      },

      "checkScrollAndShowScrollAnim" : function(){
        if(this.scrollAnim == null) return;

        setTimeout(this.showScrollAnim.bind(this),4000);
      },

      "hideScrollAnim" : function(step2){
        if(this.scrollAnim == null) return;

        this.scrollIndicator.addClass("out");
      },

      "updateScrollAnim" : function(){
        if(this.scrollAnim == null) return;

        this.scrollIndicator.find("p").html(this.scrollIndicator.find("p").attr("data-step2"));
        this.scrollIndicator.removeClass("out in");
      },

      "removeScrollAnim" : function(){
        if(this.scrollAnim == null) return;

        setTimeout(function(){
          this.scrollIndicator.addClass("out");
        }.bind(this),400);

        setTimeout(function(){
          if(this.scrollAnim != null)
            this.scrollAnim.destroy();
          this.scrollAnim = null;
          this.scrollIndicator.remove();
        }.bind(this),1000);
      }
    },

    "lanuit" : {
      "container" : null,

      "setup" : function(){
        this.container = $("section.section-1");
        this.video = this.container.find("video");
        this.videoObj = this.video.get(0);

        this.video.on("scroll-in",function(){
          if(this.videoObj.paused)
            this.videoObj.play();
        }.bind(this));

        this.video.on("scroll-reversein",function(){
          if(!this.videoObj.paused)
            this.videoObj.pause();
        }.bind(this));

        this.video.on("scroll-out",function(){
          if(!this.videoObj.paused)
            this.videoObj.pause();
        }.bind(this));
        this.video.on("scroll-reverseout",function(){
          if(this.videoObj.paused)
            this.videoObj.play();
        }.bind(this));
      }
    },

    "game" : {
      "visible" : false,
      "container" : null,
      "scene" : null,
      "fixeds" : null,
      "containerTop" : 0,
      "lastFixedsoffset" : 0,
      "gameLayer" : null,

      "setup" : function(){
        this.fixed = $(".fixed");
        this.container = $(".game");
        //this.scene = $(".game .scene");
        this.scene = $(".game-holder");
        this.gameLayer = $(".gameLayer");

        $(window).on("resize",this.updateContainerTop.bind(this));

        this.setupSliders();

        this.container.find(".game-btn").on("click",function(){
          gtag('event', 'challenge', {'event_category' : 'open_share_layer'});
        });

        this.gameLayer.find("a").on("click",function(){
          gtag('event', 'challenge', {'event_category' : 'share_on_facebook'});
        });

        this.container.find("button").on("click",function(){
          //console.log(this.gameLayer)
          this.gameLayer.addClass("show");
          setTimeout(function(){
            this.gameLayer.addClass("animate");
          }.bind(this),100);
        }.bind(this));

        this.gameLayer.find(".closer").on("click",function(){
          this.gameLayer.removeClass("animate");
          setTimeout(function(){
            this.gameLayer.removeClass("show");
          }.bind(this),900);
        }.bind(this));
      },

      "setupSliders" : function(){
        this.swipers = this.scene.find(".swiper-container");

        $.each(this.swipers,function(index,elem){
          elem = $(elem);
          var btnPrev = elem.parent().find('.swiper-button-prev');
          var btnNext = elem.parent().find('.swiper-button-next');
          var mySwiper = new Swiper (elem, {
            direction: 'horizontal',
            loop: true,
            slidesPerView:3,
            centeredSlides:true,
            speed:700,
            navigation: {
              nextEl: btnNext,
              prevEl: btnPrev,
            }
          });

          setTimeout(function(){
            mySwiper.on("slideChange",function(){
              gtag('event', 'challenge', {'event_category' : 'clothes'});
            });
          },1000);

          btnNext.on("fake-click",function(){
            mySwiper.slideNext();
          });
          btnPrev.on("fake-click",function(){
            mySwiper.slidePrev();
          });
        });
      },

      "updateContainerTop" : function(){
        if($(window).width() / $(window).height() <= 10/7) //portrait
          this.containerTop = $("footer").position().top - $(window).height();
        else //horizontal
          this.containerTop = this.container.position().top;
      },

      "updateGameScroll" : function(scroll){
        var offset = Math.round(this.containerTop - scroll);

        if(this.lastFixedsoffset != offset){
          this.fixed.css("transform","translate3d(0px," + Math.min(offset,0) + "px,0px)");
          /*if(offset > 0){
            this.scene.css("transform","translate3d(0px," + String(-offset) + "px,0px)");
          }else{
            this.scene.css("transform","translate3d(0px," + 0 + "px,0px)");
          }*/
          this.lastFixedsoffset = offset;
        }
      },

      "show" : function(){
        this.scene.addClass("active");
        this.updateContainerTop();
        this.visible = true;
      },

      "hide" : function(){
        this.visible = false;
        this.scene.removeClass("active");
        this.fixed.css("transform","translate3d(0px,0px,0px)");
        //this.scene.css("transform","translate3d(0px,0px,0px)");
      }
    },

    "sectionAnims" : {
      "setup" : function(){
        var activeBg = null;
        $.each($(".section-anim"),function(index,elem){
          elem = $(elem);
          index = elem.attr("data-index");
          var relativeBg = $(".section-bg[data-index=" + index + "]");
          var relativeSection = elem.next("section");
          elem.on("scroll-in",function(){
            window.RC.sections.intro.removeScrollAnim();
            //console.log(relativeBg)
            if(activeBg != null)
              activeBg.removeClass("active");
            activeBg = relativeBg;

            relativeBg.addClass("active");

            gtag('event', 'screen_view', { 'screen_name': relativeSection.attr("data-title")});
          });
          elem.on("scroll-reversein",function(){
            var i = index - 1;
            if(i < 1) return;
            var elem = $(".section-anim[data-index=" + i + "]");
            elem.trigger("scroll-in");
          });
        }.bind(this));

        $.each($(".scroll-anim-item"),function(index,elem){
          elem = $(elem);
          elem.on("scroll-in",function(){
            elem.addClass("animate");
          });
        }.bind(this));


        var introAnim = $(".intro-anim");
        introAnim.on("scroll-out",function(){
          RC.sections.intro.end();
        });
        introAnim.on("scroll-reverseout",function(){
          RC.sections.intro.reverse();
        });

        var gameAnim = $(".game");
        gameAnim.on("scroll-in",function(){
          RC.sections.game.show();
        });
        gameAnim.on("scroll-reversein",function(){
          RC.sections.game.hide();
        });
      }
    }
  },

  scroll : {
    "area" : null,
    "viewport" : null,
    "enabled" : false,
    "scrollElems" : [],
    "parallaxElems" : [],
    "lastScrollPos" : -1,

    "requestAnimationFrame" : null,

    "smoothScroll" : false,
    "smoothScrollBar" : null,

    "init" : function(){
      this.area = $(document.body);
      this.viewport = $(window);

      if(device.desktop() && (navigator.userAgent.indexOf("Chrome") !== -1 || navigator.userAgent.indexOf("Safari") !== -1)){
        this.smoothScroll = true;
      }

      var resizeTimeout = null;
      var scrollEnabled = null;

      if(device.desktop()){
        $(window).on("resize",function(){
          if(scrollEnabled == null){
            scrollEnabled = this.enabled;
            this.disable();
            this.resetParallaxElems();
          }

          if(resizeTimeout != null) clearTimeout(resizeTimeout);

          resizeTimeout = setTimeout(function(){
            this.parseParallaxElems();
            this.parseScrollElems();
            if(scrollEnabled)
              this.enable()
            scrollEnabled = null;
          }.bind(this),350);
        }.bind(this));
      }else{
        $(window).on("resize",this.parseScrollElems.bind(this));
        $(window).on("resize",this.parseParallaxElems.bind(this));
      }

      setTimeout(this.parseScrollElems.bind(this),700);
      setTimeout(this.parseParallaxElems.bind(this),700);

      this.requestAnimationFrame = window.requestAnimationFrame || window.mozRequestAnimationFrame ||
                              window.webkitRequestAnimationFrame || window.msRequestAnimationFrame;
      window.requestAnimationFrame = this.requestAnimationFrame;
    },

    "scrollTo" : function(elem){
      var pos = elem.position().top;

      if(!this.smoothScroll)
        TweenMax.to(window, 1.5, {scrollTo:pos});
      else if(this.smoothScrollBar == null)
        this.smoothScrollBar.scrollTo(0, pos, 1500);
    },

    "resetParallaxElems" : function(){
      var elems = $("[data-parallax]");
      $.each(elems,function(index,elem){
        elem = $(elem);
        elem.css("transform","translate3d(0px,0px,0px)");
      });
    },

    "parseParallaxElems" : function(){
      this.parallaxElems = [];
      var elems = $("[data-parallax]");
      var vHeight = this.viewport.height();

      $.each(elems,function(index,elem){
        elem = $(elem);
        var item = {
          "elem" : elem,
          "speed" : -Number(elem.attr("data-parallax")),
          "offset" : elem.offset().top - vHeight
        };
        if(this.smoothScroll && this.smoothScrollBar != null)
          item.offset += this.smoothScrollBar.scrollTop;
        this.parallaxElems.push(item);
      }.bind(this));
    },

    "parseScrollElems" : function(){
      this.scrollElems = [];
      var elems = $("[data-scroll-in],[data-scroll-out],[data-scroll-reverse]");
      var vHeight = this.viewport.height();

      var portraitDiver = (device.portrait()) ? 1 : 1;

      $.each(elems,function(index,elem){
        elem = $(elem);
        var coords = elem.offset();
        var h = elem.outerHeight();
        var item = {
          "elem" : elem,
          "h" : h
        };

        if(this.smoothScroll && this.smoothScrollBar != null)
          coords.top += this.smoothScrollBar.scrollTop;

        if(elem.attr("data-scroll-in") != undefined){
          item.in = coords.top - vHeight;
          if(elem.attr("data-scroll-in").indexOf("vh") > -1){
            item.in += vHeight * Number(elem.attr("data-scroll-in").split("vh")[0]) / (100 * portraitDiver);
          }
          item.in = Math.max(item.in,0);
          item.inDone = false;
        }
        if(elem.attr("data-scroll-out") != undefined){
          item.out = coords.top + h - vHeight;

          if(elem.attr("data-scroll-out").indexOf("vh") > -1){
            item.out += vHeight * Number(elem.attr("data-scroll-out").split("vh")[0]) / (100 * portraitDiver);
          }
          item.out = Math.max(item.out,0);
          item.outDone = false;
        }
        if(elem.attr("data-scroll-reversein") != undefined){
          item.reversein = (item.in != null) ? item.in : coords.top;
          item.reverseinDone = false;
        }
        if(elem.attr("data-scroll-reverseout") != undefined){
          item.reverseout = (item.out != null) ? item.out : coords.top + h;
          item.reverseoutDone = false;
        }

        this.scrollElems.push(item);
      }.bind(this));
    },

    "enable" : function(){
      if(this.enabled) return;

      if(this.smoothScroll && this.smoothScrollBar == null){
        $("html").addClass("smooth_scroll");
        this.smoothScrollBar = window.Scrollbar.init(document.querySelector('#main-container'));
      }

      this.enabled = true;
      this.area.addClass("enabled");

      window.requestAnimationFrame(this.updatePos.bind(this));
    },

    "disable" : function(){
      if(!this.enabled) return;

      this.enabled = false;
      this.area.removeClass("enabled");
    },

    "updatePos" : function(){
      if(this.enabled)
        window.requestAnimationFrame(this.updatePos.bind(this));

      var scrollPos = (!this.smoothScroll) ? this.viewport.scrollTop() : this.smoothScrollBar.scrollTop;

      if(this.smoothScroll && this.smoothScrollBar != null)
        this.smoothScrollBar.scrollLeft = 0;

      if(this.lastScrollPos == scrollPos) return;

      var direction = (this.lastScrollPos < scrollPos) ? 1 : -1;
      for(var i=0; i< this.scrollElems.length; i++){
        var item = this.scrollElems[i];

        if(item.in != null && !item.inDone){
          if(scrollPos >= item.in){
            item.inDone = true;
            item.elem.trigger("scroll-in");

            if(item.reversein != null) item.reverseinDone = false;
          }
        }

        if(item.out != null && !item.outDone){
          if(scrollPos >= item.out){
            item.outDone = true;
            item.elem.trigger("scroll-out");

            if(item.reverseout != null) item.reverseoutDone = false;
          }
        }

        if(item.outDone == true && direction == -1 && item.reverseout != null && !item.reverseoutDone){
          if(scrollPos <= item.reverseout){
            item.reverseoutDone = true;
            item.elem.trigger("scroll-reverseout");

            if(item.out != null) item.outDone = false;
          }
        }

        if(item.inDone == true && direction == -1 && item.reversein != null && !item.reverseinDone){
          if(scrollPos <= item.reversein){
            item.reverseinDone = true;
            item.elem.trigger("scroll-reversein");

            if(item.in != null) item.inDone = false;
          }
        }
      }

      for(var i=0; i < this.parallaxElems.length; i++){
        var item = this.parallaxElems[i];
        var pos = (scrollPos > item.offset) ? (scrollPos - item.offset) * item.speed : 0;
        item.elem.css("transform","translate3d(0px," + pos + "px,0px)");
      }

      this.lastScrollPos = scrollPos;

      if(window.RC.sections.game.visible)
        window.RC.sections.game.updateGameScroll(this.lastScrollPos);
    }
  }
};
